import _ from 'underscore';

import {STAGE_RUN_STATUS} from 'workflows/constants/StageRunConstants';
import {StageRun} from 'workflows/WorkflowConstants';

export function getSummaryStats(stageRuns: Array<StageRun>): string {
  const numInitializedRuns = stageRuns.filter((run) => run.status === STAGE_RUN_STATUS.INITIALIZED).length;
  const numCompletedRuns = stageRuns.filter((run) => run.status === STAGE_RUN_STATUS.COMPLETED).length;
  const numDiscardedRuns = stageRuns.filter((run) => run.status === STAGE_RUN_STATUS.DISCARDED).length;
  const initializedString = numInitializedRuns ? `${numInitializedRuns} initialized` : null;
  const completedString = numCompletedRuns ? `${numCompletedRuns} completed` : null;
  const discardedString = numDiscardedRuns ? `${numDiscardedRuns} discarded` : null;
  return _.compact([completedString, initializedString, discardedString]).join(' \u00B7 ');
}
